import { withInstall } from '../../../utils/with-install'
import GridLayer from './GridLayer.vue'

export const ElAmapLocaGrid = withInstall(GridLayer)
export default ElAmapLocaGrid
